import Cookie from 'cookie';

export const AUTH_COOKIE_NAME = 'jerryauth';

/**
 * add country code to phone number if it's not there
 * @param phoneNumber string
 * @returns string
 */
export const getPhoneNumberWithContryCode = (phoneNumber: string): string => {
  return phoneNumber.startsWith('+1') ? phoneNumber : `+1${phoneNumber}`;
};

/**
 * remove country code from phone number if it's there
 * @param phoneNumber string phone number
 * @returns string
 */
export const getPhoneNumberWithoutContryCode = (phoneNumber: string): string => {
  return phoneNumber.startsWith('+1') ? phoneNumber.slice(2) : phoneNumber;
};

/**
 * retrive the auth cookie
 * @returns auth cookie
 */
export const getAuthCookie = (): string | undefined => {
  const cookie = Cookie.parse(document.cookie);
  return cookie?.[AUTH_COOKIE_NAME];
};
